<template>
  <div id="hp-dropdown-search" role="region" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class="container">
      <div class="row">
        <div class="col-xs-12">
          <h2 class="text-center" id="dropdown-search-title">
            Find Your Next Vehicle
          </h2>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="vehicle-browse-ajax">
            <form class="vehicle-search-form" method="get">
              <input
                class="inventory-type set-on-load"
                name="new"
                type="hidden"
                value="true"
              />
              <div class="form-group">
                <label class="visuallyhidden" for="dropdown-vehicle-type"
                  >Select vehicle type:</label
                ><select
                  aria-labelledby="dropdown-search-title"
                  class="form-control vehicle-search search-inv-type"
                  id="dropdown-vehicle-type"
                  name="type"
                >
                  <option data="true" value="new">New</option>
                  <option data="false" value="used">Used</option></select
                ><i class="material-icons">keyboard_arrow_down</i>
              </div>
              <div class="form-group">
                <label class="visuallyhidden" for="dropdown-vehicle-make"
                  >Select vehicle make:</label
                ><select
                  aria-labelledby="dropdown-search-title"
                  class="form-control vehicle-search vehicle-search-make"
                  id="dropdown-vehicle-make"
                  name="make"
                >
                  <option value="brand">{{brandName}}</option></select
                ><i class="material-icons">keyboard_arrow_down</i>
              </div>
              <div class="form-group">
                <label class="visuallyhidden" for="dropdown-vehicle-model"
                  >Select vehicle model:</label
                ><select
                  aria-labelledby="dropdown-search-title"
                  class="form-control vehicle-search vehicle-search-model"
                  id="dropdown-vehicle-model"
                  name="model"
                >
                  <option value="default">Model</option>
                  </select
                ><i class="material-icons">keyboard_arrow_down</i>
              </div>
              <div class="form-group">
                <label class="visuallyhidden" for="dropdown-vehicle-year"
                  >Select vehicle year:</label
                ><select
                  aria-labelledby="dropdown-search-title"
                  class="form-control vehicle-search vehicle-search-year"
                  id="dropdown-vehicle-year"
                  name="year"
                >
                  <option value="default">Year</option>
                  <option value="2021">2021</option>
                  <option value="2020">2020</option>
                  <option value="2019">2019</option></select
                ><i class="material-icons">keyboard_arrow_down</i>
              </div>
              <div class="form-group" id="search-submit">
                <input
                  aria-label="Click here to submit "
                  class="btn btn-block btn-lg search-form-btn vehicle-search-submit" value="Search"
                />
              </div>
            </form>
            <br />
            <span class="matching-vehicles-found text-center">
              <div class="text-center">
                <span class="match-count"><b>181</b></span>&nbsp; matching vehicles found
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    }
  },
  mounted() {
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  #hp-dropdown-search {
    background-color: #fff;
    font-family: Helvetica, Arial, sans-serif;
    margin: auto;
    padding: 20px 0px 30px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    overflow: hidden;
    background-size: cover;
  }
  #hp-dropdown-search h2 {
    margin: 30px auto;
  }
  #hp-dropdown-search .vehicle-browse-ajax {
    width: 100%;
    max-width: 1024px;
    margin: 0 auto;
    z-index: 2;
  }
  .visuallyhidden {
    display: none;
  }
  #hp-dropdown-search .form-group {
    flex-grow: 1;
    position: relative;
  }
  #hp-dropdown-search .form-group:not(#search-submit) {
    background-color: #fff;
  }
  #hp-dropdown-search .form-group i {
    position: absolute;
    line-height: 48px;
    right: 12px;
    top: 0;
  }
  #hp-dropdown-search .form-group input, #hp-dropdown-search .form-group select {
    border-radius: 0px;
    line-height: 32px;
  }
  #hp-dropdown-search .form-control {
    display: block;
    width: 100%;
    height: 100%;
    line-height: 32px;
    position: relative;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    z-index: 1;
    background-color: transparent;
  }
  #hp-dropdown-search .search-form-btn.vehicle-search-submit {
    background-color: var(--primary-color);
    color: #fff;
    border: none;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all .3s ease;
  }
  #hp-dropdown-search[data-brand='cjdr'] .search-form-btn.vehicle-search-submit {
    background-color: var(--secondary-color);
  }
  #hp-dropdown-search .search-form-btn.vehicle-search-submit:hover {
    opacity: .7;
    color: #fff;
  }
  #hp-dropdown-search .matching-vehicles-found {
    color: #333;
    font-size: 16px;
  }

  @media(min-width: 768px) {
    #hp-dropdown-search .vehicle-search-form {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
    }
    #hp-dropdown-search .form-group {
      flex-basis: 20%;
    }
    #hp-dropdown-search .form-group:not(:last-child) {
      margin-right: 12px;
    }
  }
</style>